var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorDash = function SvgDoorDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.227 6.68A5.1 5.1 0 0 0 14.723 4H.484A.488.488 0 0 0 0 4.498c0 .128.048.256.145.337l3.1 3.097c.274.273.646.433 1.033.433h10.041c.71 0 1.308.562 1.308 1.268s-.565 1.3-1.276 1.3H7.426a.488.488 0 0 0-.484.498c0 .128.048.256.145.337l3.083 3.097c.275.273.646.433 1.033.433h3.132c4.084 0 7.168-4.333 4.892-8.618Z",
    fill: "#FF3008"
  })));
};
export default SvgDoorDash;